import Sync from "@mui/icons-material/Sync";
import { Box } from "@mui/material";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import type { NurseInShift } from "../../../utils/models";
import { NurseStatusIcons } from "../../NurseStatusIcons/NurseStatusIcons";

type Props = {
	nurseInShift: NurseInShift;
};

export const NurseInShiftMainText = ({ nurseInShift }: Props) => {
	const { getNurseNameFromId } = useHospitalData();
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 0.5,
				justifyContent: "start",
			}}
		>
			{getNurseNameFromId(nurseInShift.nurseId)}
			<NurseStatusIcons nurseId={nurseInShift.nurseId} charge={nurseInShift.charge} trainingStatus={nurseInShift.trainingStatus} />
			{nurseInShift.recurringShiftId != null && <Sync fontSize={"inherit"} />}
		</Box>
	);
};
